import { useMutation } from '@tanstack/react-query';
import { api } from './api';

export type PiiKind = 'my_number' | 'ssn' | 'uk_ni' | 'de_tax_id' | 'bank_account';

export function usePiiStore() {
  return useMutation({
    mutationFn: async ({ employeeId, kind, plaintext }: { employeeId: string; kind: PiiKind; plaintext: string }) => {
      const r = await api.post<{ kind: PiiKind; last4: string }>(`/api/employees/${employeeId}/pii/store`, { kind, plaintext });
      return r.data;
    },
  });
}

export function usePiiReveal() {
  return useMutation({
    mutationFn: async ({ employeeId, kind, reason }: { employeeId: string; kind: PiiKind; reason: string }) => {
      const r = await api.post<{ kind: PiiKind; plaintext: string }>(`/api/employees/${employeeId}/pii/reveal`, { kind, reason });
      return r.data;
    },
  });
}

export function usePiiErase() {
  return useMutation({
    mutationFn: async ({ employeeId, kind, reason }: { employeeId: string; kind: PiiKind; reason: string }) => {
      const r = await api.post<{ ok: boolean }>(`/api/employees/${employeeId}/pii/erase`, { kind, reason });
      return r.data;
    },
  });
}
